import { render, staticRenderFns } from "./Destinations.vue?vue&type=template&id=8ebd359e&scoped=true&"
import script from "./Destinations.vue?vue&type=script&lang=js&"
export * from "./Destinations.vue?vue&type=script&lang=js&"
import style0 from "./Destinations.vue?vue&type=style&index=0&id=8ebd359e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebd359e",
  null
  
)

export default component.exports